<template>
  <div class="flex flex-column flex-grow-1 w-full" :class="`${AppConfig.theme}-theme`">
    <label class="label-top">{{ props.label }}</label>
    <div class="p-float-label">
      <Dropdown
        v-model="model"
        :options="props.options"
        :optionLabel="props.optionsLabel"
        :optionValue="props.optionsValue"
        :placeholder="props.label"
        :filter="props.filter"
        v-bind="$attrs"
        style="width: 100%"
        :virtualScrollerOptions="{ itemSize: 58 }"
      />
      <label class="label-border">{{ props.label }}</label>
      <input style="display: none;" type="text" :required="props.required" v-model="v$.value.$model" v-bind="$attrs" />
    </div>
    <div>
      <small v-if="v$.value.$error" class="p-error">{{ props.label }} is required.</small>
      <small v-if="v$.value.$error == [] && props.required" class="help-text">*{{ t('general.required') }}</small>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, reactive } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { useI18nUtils } from '@/composables/utils/useI18nUtils.js'
import AppConfig from '~/config/appConfig.js'

const props = defineProps({
  modelValue: String,
  options: Array,
  optionsLabel: { type: String, required: false, default: 'label' },
  optionsValue: { type: String, required: false, default: 'value' },
  label: { type: String, required: true },
  filter: { type: Boolean, required: false, default: false},
  required: Boolean
})

const model = defineModel()

const { t } = useI18nUtils()
const value = reactive(model)

const rules = computed(() => {
  const v = {}
  if (props.required) {
    v.value = { required }
  } else {
    v.value = {}
  }
  return v
})

const v$ = useVuelidate(rules, { value })
</script>
<style scoped>
.dropdown-border {
  height: 40px;
  box-shadow: 1px 2px 4px #00000029;
  border: 0.5px solid #E5E5E5;
  border-radius: 8px;
}

label {
  font-weight: 550;
  color: #013315;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
}

.label-top {
  margin-bottom: 8px;
  display: none;
}

@media screen and (min-width: 768px) {
  .label-top {
    display: block;
  }

  .label-border {
    display: none;
  }
  .p-dropdown {
    height: 40px !important;           /* match v-text-field height */
    display: flex;
    align-items: center;
    border-radius: 8px;                /* same as text field */
    padding: 0 !important;
    box-sizing: border-box;
  }
  .p-dropdown .p-dropdown-label {
    display: flex !important;
    align-items: center !important;
    padding: 0.5rem 1rem !important;
    line-height: 1.4 !important;
  }

}

.sbg-theme {
  label {
    color: rgba(0, 0, 0, 0.6);
    font-weight: normal;
    width: auto;
  }

  .label-top {
    display: none;
  }

  .label-border {
    display: block;
  }

  .p-focus ~ label {
    color: #00afa5;
  }

  :deep(.p-dropdown) {
    border-radius: 8px;
    height: auto !important;
    line-height: normal;
  }

  :deep(.p-icon) {
    color: var(--primary-color);
  }
}

</style>